export default "__VITE_ASSET__BpFYn3x8__"